import { render, staticRenderFns } from "./DealerDetailsRight.vue?vue&type=template&id=0f1c2829&scoped=true"
import script from "./DealerDetailsRight.vue?vue&type=script&lang=js"
export * from "./DealerDetailsRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c2829",
  null
  
)

export default component.exports